<template>
  <div v-if="isShowH5NavBar" class="fixed-header">
    <div class="fixed-inner" :class="{ black: black }">
      <van-icon name="arrow-left" v-if="left" @click="backTap" />
      <span>{{ title }}</span>
      <div class="btns-right">
        <i v-if="isApp && shareData" class="ic ic-share" @click="share"></i>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { mapState } from "vuex";
import { Icon } from "vant";
import { callAppHandler } from "../utils/index";
import wxShareInit from "../utils/wxshare";

Vue.use(Icon);
export default {
  name: "FixedHeader",
  props: ["title", "black", "left", "isHome", "shareData"],
  computed: {
    ...mapState(["isApp", "isShowH5NavBar"]),
  },
  data() {
    return {};
  },
  mounted() {
    wxShareInit(this.shareData);
  },
  methods: {
    backTap() {
      if (this.isApp && this.isHome) {
        callAppHandler({
          type: "back",
        });
      } else {
        this.$router.back();
      }
    },

    share() {
      callAppHandler({
        type: "share",
        params: this.shareData,
      });
    },
  },
};
</script>

<style lang="less">
@import "../assets/style/main";

.fixed-header {
  position: relative;
  height: 86 / @baseSize;
  z-index: 2;
  box-sizing: border-box;
  &.hidden {
    display: none;
  }

  .van-icon {
    font-size: 40 / @baseSize;
  }

  .fixed-inner {
    box-sizing: border-box;
    position: fixed;
    font-size: 36 / @baseSize;
    text-align: center;
    font-weight: 400;
    top: 0;
    left: 0;
    right: -2 / @baseSize;
    bottom: -2 / @baseSize;
    line-height: 88 / @baseSize;
    height: 88 / @baseSize;
    color: #333333;
    background-color: #ffffff;
    border-bottom: 1px solid #eeeeee;

    &.black {
      color: #ffffff;
      background-color: #27282d;
      border-bottom: 1px solid #27282d;
    }

    .van-icon-arrow-left {
      position: absolute;
      left: 30 / @baseSize;
      top: 22 / @baseSize;
    }

    .btns-right {
      position: absolute;
      top: 0;
      right: 30 / @baseSize;
      .ic {
        margin-left: 20 / @baseSize;
        display: inline-block;
        width: 36 / @baseSize;
        height: 36 / @baseSize;
      }
      .ic-share {
        background: url(../assets/imgs/ic_share_white.png) center no-repeat;
        background-size: contain;
      }
    }
  }
}
</style>
